import { vservice } from '@niknevis/vue-modules'
import { BaseRequestLoadingHandler } from '@/modules/shared/interfaces/base-request-loading-handler.interface'
import { ContentCampaignPaymentLinkRequest } from '@/modules/content-campaign/models/content-campaign-request.model'
import { PanelContentCampaignService } from '@/modules/content-campaign/services/panel-content-campaign.service'
import { BasePaymentlinkUseCase } from '@/modules/transaction/use-cases/shared/base-paymentlink.use-case'

@vservice()
export class PanelContentCampaignPaymentlinkUseCase extends BasePaymentlinkUseCase
  implements BaseRequestLoadingHandler {
  constructor(
    private readonly service: PanelContentCampaignService
  ) {
    super()
  }

  isLoading = false
  isSuccess = false

  execute(contentCampaignId: number, data: ContentCampaignPaymentLinkRequest) {
    this.isLoading = true

    return this.service.paymentLink(contentCampaignId, this.requestData(data))
      .then((res) => {
        this.isLoading = false
        return res.data
      }).catch((err) => {
        this.isLoading = false
      })
  }

}
